import React, { useState } from 'react'
import { Formik, Form, Field } from 'formik'
import { FiEdit } from 'react-icons/fi'
import { FaRegSave } from 'react-icons/fa'
import { toast } from 'react-toastify'

import Yup from '../../../services/yup'

import Spinner from '../../../components/Spinner'
import Modal from '../../../components/Modal'
import ActionFooter from '../../../components/ActionFooter'
import { Textbox, Button } from '../../../components/Form'

import { api, authHeaders } from '../../../services/api'

import { Container, ModalContainer } from './styles'

const baseInitialValues = {
    site: '',
    nome_fantaisia: ''
}

const boxName = 'Dados corporativos'

const validation = Yup.object().shape({
    site: Yup.string(),
    nome_fantasia: Yup.string()
})

export default function ({ pessoa, reload, editable = true }) {
    const [editMode, setEditMode] = useState(false)
    const [initialValues, setInitialValues] = useState(baseInitialValues)

    async function handlePrepareEdit() {
        const {
            empresa: {
                site,
                nome_fantasia
            }
        } = pessoa

        setInitialValues({
            site,
            nome_fantasia,
            pessoa_id: pessoa.id
        })

        setEditMode(true)
    }

    async function handleEdit(values) {
        try {
            const {
                site, nome_fantasia, pessoa_id
            } = values

            await api.put(`empresa/${pessoa_id}`, {
                site, 
                nome_fantasia
            }, authHeaders())

            toast.success('Dados atualizados.')

            setEditMode(false)

            setInitialValues(baseInitialValues)

            reload()
        } catch (e) {
            toast.error('Erro ao atualizar os dados corporativos.')
        }
    }

    return (
        <>
            <Container className="animated fadeInUp delay-200ms no-responsive">
                <h1>{boxName}</h1>

                {editable ? (
                    <FiEdit
                        size={20}
                        data-tip="Editar"
                        data-for="tooltip"
                        onClick={handlePrepareEdit}
                    />
                ) : (
                    <div />
                )}

                <div />

                {pessoa ? (
                    <div>
                        <span>
                            <b>Nome fantasia: </b>
                            {pessoa.dados_pessoais?.nome_fantasia || 'não informado'}
                        </span>

                        <span>
                            <b>Site: </b>
                            {pessoa.dados_pessoais?.site || 'não informado'}
                        </span>
                    </div>
                ) : (
                    <Spinner />
                )}
            </Container>

            <Modal
                isOpen={editMode}
                handleClose={() => setEditMode(false)}
                title={boxName}
            >
                <ModalContainer>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validation}
                        onSubmit={editMode ? handleEdit : () => null}
                        enableReinitialize
                    >
                        {({ isSubmitting }) => (
                            <Form>
                                <Field type="hidden" name="pessoa_id" />

                                <Textbox
                                    label="Nome fantasia"
                                    name="nome_fantasia"
                                />

                                <Textbox
                                    label="Site"
                                    name="site"
                                />

                                <ActionFooter>
                                    <Button type="submit" loading={isSubmitting} className="white">
                                        Salvar alterações
                                        <FaRegSave />
                                    </Button>
                                </ActionFooter>
                            </Form>
                        )}
                    </Formik>
                </ModalContainer>
            </Modal>
        </>
    )
}
